module.exports = __webpack_public_path__ + "static/media/zxs_app.629e03d5.png";